export const HolidayHoursPath = '/images/dynamic/hours/';

export interface HolidayHoursImage {
  imageID: number;
  src?: string;
}
